import { useEffect } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, Controller } from 'react-hook-form'

import { expertSchema } from '../../../../../../validators/expertSchema'
import { Button } from '../../../../../../components/Button'
import { Input } from '../../../../../../components/FormElements/Input'
import { type ExpertPersistence } from '../../../../../../types/persistence/expert-persistence'
import { isEmailAvailable } from '../../../../../../utils/isEmailAvailable'

type ExpertFormProps = {
  isSubmitting: boolean
  defaultValues?: ExpertPersistence
  onSubmit: (data: ExpertPersistence) => void
}

export const ExpertForm = ({ isSubmitting, defaultValues, onSubmit }: ExpertFormProps) => {
  const { control, formState, reset, handleSubmit, clearErrors, setError } =
    useForm<ExpertPersistence>({
      defaultValues,
      resolver: yupResolver(expertSchema),
      mode: 'onChange',
    })

  useEffect(() => {
    return () => {
      reset()
    }
  }, [reset])

  return (
    <form
      className="p-6 max-h-[80vh] overflow-y-auto scrollbar"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="mb-14">
        <div className="mb-8">
          <Controller
            name="name"
            control={control}
            render={({
              field: { value = '', onChange },
              fieldState: { invalid, error },
            }) => (
              <Input
                label="Nome completo"
                autoFocus
                placeholder="Nome completo"
                isValid={!invalid && !!error}
                value={value}
                onChange={onChange}
                errorMessage={error?.message}
              />
            )}
          />
        </div>

        <div className="mb-8">
          <Controller
            name="email"
            control={control}
            render={({
              field: { value = '', onChange },
              fieldState: { invalid, error },
            }) => (
              <Input
                label="E-mail*"
                placeholder="E-mail"
                isValid={!invalid && !!error}
                value={value}
                onChange={async (event) => {
                  onChange(event)

                  const emailFieldValue = event.target.value
                  const defaultEmailValue = defaultValues?.email
                  const isNotEmailAvailable = !(await isEmailAvailable(
                    emailFieldValue,
                    defaultEmailValue
                  ))

                  if (isNotEmailAvailable) {
                    setError('email', { message: 'E-mail já em uso' })
                    return
                  }

                  clearErrors('email')
                }}
                errorMessage={error?.message}
              />
            )}
          />
        </div>
      </div>

      <Button
        type="submit"
        disabled={!formState.isValid}
        isLoading={isSubmitting}
        fullWidth
      >
        {defaultValues ? 'Salvar' : 'Cadastrar'}
      </Button>
    </form>
  )
}
